<template>
  <van-popup
    v-model="show"
    position="bottom"
    round
    safe-area-inset-bottom
    class="gift-modal"
    @click-overlay="close"
  >
    <div class="gift-modal-header">
      <div class="gift-modal-title">查看赠品</div>
      <div class="gift-modal-close" @click="close">×</div>
    </div>
    <div class="gift-modal-content">
      <div class="gift-card">
        <div class="gift-summary">
          首{{ conPackType === 2 ? "日" : "周" }}礼 x{{ totalGiftCount }}
        </div>
        <div
          v-for="(item, index) in displayGiftList"
          :key="`${item.gift_product_type}-${index}`"
          class="gift-row"
        >
          <div class="gift-tag">
            <img v-if="getGiftImage(item)" :src="getGiftImage(item)" alt="" />
            <img
              v-else-if="+item.gift_product_type === 201"
              src="https://static0.xesimg.com/platform-fe/xes-mall/renewal-center/image/couponDefault.png"
              alt=""
            />
            <img
              v-else-if="[101, 105, 107].includes(+item.gift_product_type)"
              src="https://static0.xesimg.com/platform-fe/xes-mall/renewal-center/image/productDefault.png"
              alt=""
            />
            <img
              v-else-if="+item.gift_product_type === 100"
              src="https://static0.xesimg.com/platform-fe/xes-mall/renewal-center/image/courseDefault.png"
              alt=""
            />
          </div>
          <div class="gift-info">
            <div
              v-if="getGiftTypeText(item.gift_product_type)"
              :class="[
                'gift-type-tag',
                getGiftTypeClass(item.gift_product_type),
              ]"
            >
              {{ getGiftTypeText(item.gift_product_type) }}
            </div>
            <div class="gift-name">{{ item.gift_name || "礼品名称" }}</div>
          </div>
          <div class="gift-num">x{{ item.gift_num || 1 }}</div>
        </div>
      </div>
      <div class="gift-modal-btn" @click="close">我知道了</div>
    </div>
  </van-popup>
</template>
<script>
export default {
  props: {
    giftInfo: {
      type: Array,
      default: () => [],
    },
    conPackType: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      show: false,
      currentGiftInfo: [],
      defaultGiftInfo: [
        {
          gift_name: "礼品名称",
          gift_num: 1,
          gift_product_type: 201,
        },
        {
          gift_name: "礼品名称",
          gift_num: 1,
          gift_product_type: 105,
        },
        {
          gift_name: "礼品名称",
          gift_num: 1,
          gift_product_type: 100,
        },
      ],
    };
  },
  computed: {
    displayGiftList() {
      return this.currentGiftInfo.length
        ? this.currentGiftInfo
        : this.defaultGiftInfo;
    },
    totalGiftCount() {
      return this.displayGiftList.reduce(
        (total, item) => total + Number(item.gift_num || 1),
        0
      );
    },
  },
  methods: {
    init(giftInfo) {
      const list =
        Array.isArray(giftInfo) && giftInfo.length ? giftInfo : this.giftInfo;
      this.currentGiftInfo =
        Array.isArray(list) && list.length ? list : this.defaultGiftInfo;
      this.show = true;
    },
    getGiftImage(item = {}) {
      if (Array.isArray(item.pic_url)) {
        return item.pic_url[0] || "";
      }
      return item.pic_url || "";
    },
    getGiftTypeText(type) {
      const typeMap = {
        201: "优惠券",
        100: "课程",
      };
      if ([101, 105, 107].includes(+type)) {
        return "实物";
      }
      return typeMap[+type] || "";
    },
    getGiftTypeClass(type) {
      const classMap = {
        201: "gift-type-tag-coupon",
        100: "gift-type-tag-course",
      };
      if ([101, 105, 107].includes(+type)) {
        return "gift-type-tag-product";
      }
      return classMap[+type] || "";
    },
    close() {
      this.show = false;
    },
  },
};
</script>
<style lang="less" scoped>
.gift-modal {
  overflow: hidden;
}

.gift-modal-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 52px;
  background: #fff;
}

.gift-modal-title {
  color: #333333;
  font-family: "PingFang SC";
  font-size: 17px;
  font-weight: 500;
  line-height: 24px;
}

.gift-modal-close {
  width: 16px;
  //   height: 16px;
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  color: #333;
  font-size: 28px;
  line-height: 16px;
  font-weight: 300;
}

.gift-modal-content {
  padding: 0px 16px;
  background: #fff;
}

.gift-card {
  max-height: 297px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 16px 12px;
  border-radius: 16px;
  background: #f7f7f8;
}

.gift-summary {
  margin-left: 8px;
  margin-bottom: 16px;
  color: #333333;
  font-family: "PingFang SC";
  font-size: 15px;
  font-weight: 500;
  line-height: 22px;
}

.gift-row {
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  margin: 16px 0;
}

.gift-tag {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  margin-right: 14px;
  border-radius: 8px;
  color: #fff;
  font-family: "PingFang SC";
  font-size: 13px;
  font-weight: 600;
  flex-shrink: 0;
  img {
    width: 60px;
    height: 60px;
    border-radius: 8px;
  }
}

.gift-info {
  display: flex;
  align-items: center;
  flex: 1;
  margin-right: 12px;
  width: 28px;
}

.gift-type-tag {
  flex-shrink: 0;
  margin-right: 4px;
  padding: 2px 6px;
  border-radius: 4px;
  color: #fff;
  font-family: "PingFang SC";
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
}

.gift-type-tag-course {
  background: #589BF5;
}

.gift-type-tag-product {
  background: #E0A367;
}

.gift-type-tag-coupon {
  background: #F93834;
}

.gift-name {
  flex: 1;
  min-width: 0;
  color: #333333;
  font-family: "PingFang SC";
  font-size: 15px;
  font-weight: 400;
  line-height: 21px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.gift-num {
  width: 14px;
  color: #333;
  font-family: "PingFang SC";
  font-size: 15px;
  font-weight: 400;
  line-height: 21px;
}

.gift-modal-btn {
  width: 288px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  margin: 22px auto 0;
  margin-bottom: 9px;
  // padding: 9px 43px 9px 44px;
  border-radius: 30px;
  background: #f93834;
  color: #fff;
  font-family: "PingFang SC";
  font-size: 17px;
  font-weight: 500;
  // line-height: 25px;
}
</style>
